import { type ReactElement } from 'react';
import { FormattedMessage } from 'react-intl-next';

export interface FormattedMessages {
	title: ReactElement;
	description: ReactElement;
	primaryButton: ReactElement;
	secondaryButton?: ReactElement;
}

export const formattedMessages = {
	title: (
		<FormattedMessage
			id="growth-starburst.ep-migration-inapp-3282.title" // components[0].title
			defaultMessage="We’re having trouble with your plan" // components[0].title
			description="Heading"
		/>
	),
	description: (
		<FormattedMessage
			id="growth-starburst.ep-migration-inapp-3282.description" // components[0].body
			defaultMessage="We’ve kept you on the Standard plan of Confluence for now." // components[0].body
			description="Description"
		/>
	),
	primaryButton: (
		<FormattedMessage
			id="growth-starburst.ep-migration-inapp-3282.primary-button" // components[0].primaryText
			defaultMessage="Upgrade options" // components[0].primaryText
			description="Primary Button"
		/>
	),
	secondaryButton: (
		<FormattedMessage
			id="growth-starburst.ep-migration-inapp-3282.secondary-button" // components[0].secondaryText (if present)
			defaultMessage="Dismiss" // components[0].secondaryText (if present)
			description="Secondary Button"
		/>
	),
};
